
import { Component, Vue } from "vue-property-decorator";
import { SMCases } from "@/store";
import { REPORT_GENERATED_SERVICE_STATUS, COMPLETE_SERVICE_STATUS } from "@/constants/services";

const TRUE_AS_STRING = "true";

@Component({
  components: {
    WidgetReport: () => import("@/components/Report/WidgetReport.vue"),
    Report: () => import("@/components/Report/Report.vue"),
  },
})
export default class VTemplateReport extends Vue {
  async mounted() {
    await SMCases.fetchCaseTabs(SMCases.caseId);
  }

  get caseStatus() {
    return SMCases.caseStatus;
  }

  get isReportGenerated() {
    return [REPORT_GENERATED_SERVICE_STATUS, COMPLETE_SERVICE_STATUS].includes(this.caseStatus);
  }

  get isEditable(): boolean {
    const { isEditable } = this.$attrs;

    return typeof isEditable === "boolean" ? isEditable : isEditable === TRUE_AS_STRING;
  }
}
